import React, { useMemo } from "react";
import { Box, Typography, TextField } from "@mui/material";
import DesignMetaRow from "./DesignMetaRow";
import DesignDesignCard from "./DesignDesignCard";
import { parseDesignSnapshot } from "./designUtils";

/** Shared width for readonly design type field and design card on Overview */
export const DESIGN_OVERVIEW_BLOCK_WIDTH = 400;

const DesignOverview = ({ data }) => {
  const snapshot = useMemo(() => parseDesignSnapshot(data?.snapshot), [data?.snapshot]);
  const design = snapshot?.design;
  const oldDesign = design?.oldDesign;

  const designTypeDisplay = oldDesign?.type ?? "";

  return (
    <Box sx={{ mt: 2, width: "100%" }}>
      <DesignMetaRow changeRequest={data} />

      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#0d0d0e", mb: 1.5 }}>
        Selected Design Type
      </Typography>
      <TextField
        fullWidth
        value={designTypeDisplay}
        placeholder="—"
        InputProps={{ readOnly: true }}
        inputProps={{ "aria-readonly": true }}
        sx={{
          maxWidth: DESIGN_OVERVIEW_BLOCK_WIDTH,
          width: "100%",
          mb: 3,
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            backgroundColor: "#fafafa",
            "& fieldset": { borderColor: "#E4E5E7" },
            "&:hover fieldset": { borderColor: "#d1d5db" },
          },
          "& .MuiInputBase-input": {
            color: "#0d0d0e",
            fontWeight: 500,
            cursor: "default",
          },
        }}
      />

      {oldDesign ? (
        <DesignDesignCard design={oldDesign} imageMaxHeight={240} maxWidth={DESIGN_OVERVIEW_BLOCK_WIDTH} />
      ) : (
        <Typography sx={{ fontSize: "14px", color: "#949DAA" }}>No design details in snapshot.</Typography>
      )}
    </Box>
  );
};

export default DesignOverview;
